import { createElement, type ReactElement, useState } from "react"

import { useRoleMeta } from "@/user/session"
import { MainLotteryModal } from "./MainLotteryModal"

interface LotteryHandle {
    start: () => void
    refreshLotteryStatus: () => void
    modal: ReactElement
}

export const useLottery = (): LotteryHandle | null => {
    const roleMeta = useRoleMeta()
    const [open, setOpen] = useState(false)
    if (!roleMeta) return null
    return {
        start: () => setOpen(true),
        refreshLotteryStatus: () => {},
        modal: createElement(MainLotteryModal, { open, onClose: () => setOpen(false) }),
    }
}
